/**
 * PaymentTimeline — Renders the payment's statusTimeline using the reusable StatusTimeline component.
 */
import { useAppSelector } from 'src/store/hooks';
import { StatusTimeline } from 'src/components/common/StatusTimeline';

export const PaymentTimeline = () => {
  const payment = useAppSelector(state => state.payment.data);

  if (!payment?.statusTimeline || payment.statusTimeline.length === 0) return null;

  return (
    <StatusTimeline
      title="Payment Lifecycle"
      timeline={payment.statusTimeline}
    />
  );
};
